import { Directive, HostListener, EventEmitter, Output, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { HeightValidatorService } from '../services/height-validator.service';
import { DeckHeightService } from '../services/deck-height.service';
import { ToasterService } from 'angular2-toaster';

@Directive({
  selector: '[appInchInputHeightValidator]',
})
export class InchInputHeightValidatorDirective {

  public lastValidFeetValue: number = 8;
  private el: any;
  @Output() ngModelChange = new EventEmitter();

  constructor(
    public ngControl: NgControl,
    private heightValidatorService: HeightValidatorService,
    private elementRef: ElementRef,
    private deckHeightService: DeckHeightService,
    private toasterService: ToasterService
  ) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(value) {
    this.changeFeetValidator(this.el.value);
  }

  @HostListener('blur', ['$event'])
  focusOut(value) {
    let deckheightInFeetRounded = Math.floor(this.deckHeightService.getDeckHeight() / 12);
    this.lastValidFeetValue = this.deckHeightService.getDeckHeight() - deckheightInFeetRounded*12;
    if (this.changeFeetValidator(this.el.value)) {
      let element = Number(this.el.value);
      this.ngModelChange.emit(this.el.value);
    }
    else {
      this.el.value = this.lastValidFeetValue;
      this.ngModelChange.emit(this.el.value);
      this.showToast('warning', 'Invalid value', "Minimal height exceeded");
    }
  }

  @HostListener('keydown.enter', ['$event'])
  keydownEnter(value) {
    let deckheightInFeetRounded = Math.floor(this.deckHeightService.getDeckHeight() / 12);
    this.lastValidFeetValue = this.deckHeightService.getDeckHeight() - deckheightInFeetRounded*12;
    if (this.changeFeetValidator(this.el.value)) {
      let element = Number(this.el.value);
      this.ngModelChange.emit(this.el.value);
    }
    else {
      this.el.value = this.lastValidFeetValue;
      this.ngModelChange.emit(this.el.value);
      this.showToast('warning', 'Invalid value', "Minimal height exceeded");
    }
  }


  changeFeetValidator(value): boolean {
    let delta = this.deckHeightService.getDeckHeight() - this.heightValidatorService.getMinHeight()*0.393701;
    if (delta - (this.lastValidFeetValue-value)>=0 ||this.lastValidFeetValue-value<=0) {
      this.lastValidFeetValue = value;
      return true;
    }
    else {
      return false;
    }
  }
  showToast(type: string, title: string, body: string) {
    this.toasterService.popAsync(type, title, body);
  }
} 


// WEBPACK FOOTER //
// ./src/app/directives/inch-input-height-validator.directive.ts